import ApiService from '@core/api/services/ApiService';
import UrlResolver from '@core/url-resolver/UrlResolver';
import debounce from 'lodash/debounce';
import React from 'react';
export var SearchType;
(function (SearchType) {
    SearchType[SearchType["SiteWide"] = 0] = "SiteWide";
    SearchType[SearchType["Products"] = 1] = "Products";
    SearchType[SearchType["TechnicalLibrary"] = 2] = "TechnicalLibrary";
    SearchType[SearchType["MediaArticle"] = 3] = "MediaArticle";
})(SearchType || (SearchType = {}));
export var OrderType;
(function (OrderType) {
    OrderType[OrderType["Relevance"] = 0] = "Relevance";
    OrderType[OrderType["Alphabetically"] = 1] = "Alphabetically";
    OrderType[OrderType["AlphabeticallyDescending"] = 2] = "AlphabeticallyDescending";
    OrderType[OrderType["DateDescending"] = 3] = "DateDescending";
    OrderType[OrderType["Date"] = 4] = "Date";
    OrderType[OrderType["NodeOrder"] = 5] = "NodeOrder";
})(OrderType || (OrderType = {}));
const useSiteSearch = (params) => {
    const [response, setResponse] = React.useState(params.initialData ?? undefined);
    const [isLoading, setIsLoading] = React.useState(false);
    const fetchResults = async (p, append = false) => {
        setIsLoading(true);
        const apiResponse = await ApiService.request({
            baseUrl: UrlResolver.getDomain(),
            method: 'GET',
            controller: 'search',
            slug: 'performsearch',
            params: { ...p },
        });
        if (append && apiResponse?.result && apiResponse.result.results && response?.results) {
            setResponse({
                ...apiResponse.result,
                results: [...response.results, ...apiResponse.result.results],
            });
        }
        else {
            setResponse(apiResponse.result);
        }
        setIsLoading(false);
    };
    const debouncedFetchResults = React.useCallback(debounce(fetchResults, 275), []);
    React.useEffect(() => {
        !params.disableRequest && debouncedFetchResults(params.request);
    }, [params.request.searchTerm, params.disableRequest]);
    React.useEffect(() => {
        !params.disableRequest && debouncedFetchResults(params.request);
    }, [params.request.selectedFilters?.length, params.disableRequest]);
    React.useEffect(() => {
        !params.disableRequest && debouncedFetchResults(params.request, true);
    }, [params.request.pageIndex, params.disableRequest]);
    return { response, isLoading };
};
export default useSiteSearch;
